"use strict";import{TableHeadCell as e}from"./src/TableHeadCell.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-table-head-cell",e);
//# sourceMappingURL=sp-table-head-cell.js.map
